import MenuCategory from '../../components/MenuCategory/MenuCategory';
import { menuData } from '../../data/menuData';
import './Menu.css';

function Menu() {
  return (
    <div className="menu-page">
      <div className="page-header">
        <h1>Our Menu</h1>
        <div className="section-divider"></div>
        <p className="menu-page__intro">
          A curated selection of dishes blending traditional Italian flavors with modern innovation.
        </p>
      </div>

      <section className="section">
        <div className="container">
          {menuData.map((section, index) => (
            <MenuCategory
              key={index}
              category={section.category}
              items={section.items}
            />
          ))}
        </div>
      </section>
    </div>
  );
}

export default Menu;
